<template>
  <div>
    <div
      v-for="(autreChargeSpecifique, acs) in charges"
      :key="acs+10"
    >
      <div
        class="d-flex"
        :class="$vuetify.breakpoint.mobile ? 'flex-column' : 'justify-center fixed-height'"
      >
        <div
          class="intro text-gris-fonce"
          :class="$vuetify.breakpoint.mobile ? '' : 'pl-2 align-self-center fixed-width'"
        >
          {{ autreChargeSpecifique[0].comparateurMargeParametre.typeRubrique.libelleSousRubrique }} ({{ autreChargeSpecifique[0].comparateurMargeParametre.typeRubrique.unite ? autreChargeSpecifique[0].comparateurMargeParametre.typeRubrique.unite : '€/ha' }})
        </div>
        <div class="d-flex ">
          <span
            v-for="(autreChargeParGraine, indexA) in autreChargeSpecifique"
            :key="indexA"
            class="align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'w-100' : 'px-2 fixed-width'"
          >
            <div
              v-if="($vuetify.breakpoint.mobile && indexA <=1 ) || !$vuetify.breakpoint.mobile"

              :class="$vuetify.breakpoint.mobile ? 'px-1 max-width-165' : ''"
            >
              <div
                v-if="autreChargeParGraine.comparateurMargeParametre.id && autreChargeParGraine.comparateurMargeParametre.typeRubrique"
              >
                <BaseInputNumberIncrement
                  :object-value="autreChargeParGraine.comparateurMargeParametre.valeurAdmin"
                  :min="autreChargeParGraine.comparateurMargeParametre.valeurAdmin.minimum"
                  :max="autreChargeParGraine.comparateurMargeParametre.valeurAdmin.maximum"
                  :is-disabled="!peutModifier"
                  :has-same-value="hasSameValue(autreChargeParGraine.comparateurMargeParametre)"
                  :has-droit-ecriture="peutModifier"
                  :has-erreur-saisie="hasErreurSaisie(autreChargeParGraine)"
                  :is-lock="!estAbonne"
                  @update="onUpdate($event, autreChargeParGraine)"
                  @openModalAbonnement="openModalAbonnement"
                />
              </div>
              <div
                v-else
                class="intro text-gris-fonce"
                :class="$vuetify.breakpoint.mobile ? '' : 'fixed-width'"
              >
                <div
                  class="align-center"
                >
                  {{
                    autreChargeParGraine.comparateurMargeParametre.valeurDefaut
                      ?
                        autreChargeParGraine.comparateurMargeParametre.valeurDefaut
                      :
                        autreChargeParGraine.comparateurMargeParametre.typeCulture!= null ? '-' : ''
                  }}
                </div>
              </div>
            </div>
          </span>
        </div>
      </div>
    </div>
    <v-card
      color="primary"
      elevation="0"
      class="py-3 mt-3"
    >
      <BandeauTotaux
        libelle="Total charges spécifiques (€/ha)"
        :valeurs="totaux"
        :has-loading="hasLoading"
        :has-erreur="hasErreur"
      />
    </v-card>
  </div>
</template>
<script>
/*
 * Section "charges specifiques" du comparateur de marge, extraite de l'ecran
 * principal (2 000 lignes).
 *
 * Le composant ne connait ni le store ni les habilitations : tout ce dont il
 * a besoin arrive en props. C'est ce qui le rend testable en isolation - a la
 * difference de la section telle qu'elle vivait dans l'ecran, ou son
 * affichage dependait de trois etats sans rapport, d'une condition derivee et
 * d'une initialisation asynchrone.
 */
import BaseInputNumberIncrement from '@/components/form/base-input-number-increment.vue'
import BandeauTotaux from './bandeau-totaux.vue'
import { aMemeValeurAdmin } from '@/utils/comparateur-marge'

export default {
  name: 'ChargesSpecifiques',
  components: { BaseInputNumberIncrement, BandeauTotaux },
  props: {
    // Charges groupees par sous-rubrique, une entree par culture comparee
    charges: {
      type: Array,
      default: () => []
    },
    // Totaux par culture, tels que renvoyes par le serveur
    totaux: {
      type: Array,
      default: null
    },
    hasErreur: {
      type: Array,
      default: () => [false, false, false]
    },
    hasLoading: {
      type: Array,
      default: () => [false, false, false]
    },
    // Parametre actuellement en erreur de saisie, s'il y en a un
    paramErreur: {
      type: Object,
      default: null
    },
    estAbonne: {
      type: Boolean,
      default: false
    },
    peutModifier: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hasSameValue (parametre) {
      return aMemeValeurAdmin(parametre)
    },
    // Semantique identique a celle de l'ecran d'origine : paramErreur recoit
    // le meme type d'objet (une donnee adherent), on compare donc les .id.
    hasErreurSaisie (parametre) {
      return this.paramErreur != null && parametre.id !== this.paramErreur.id
    },
    onUpdate (evenement, charge) {
      this.$emit('update', evenement, charge)
    },
    openModalAbonnement () {
      this.$emit('openModalAbonnement')
    }
  }
}
</script>
